import React, { Component } from 'react';
import { PureComponent } from 'react';
import config from '../../common/config';
import { hasTeam, getIsLateOnboardUser } from '../../common';
import { isPlayerInTeam, getPlayerInteam } from './helper'
import { Consume } from '../../Context/Consumer';
import { LoginContext } from '../../Context/index'


class status extends PureComponent {


    render() {
        let { config, trans, getTrans, rawMatchDay, gamedays, playerDetailsObj, teamData, showGeneric } = this.props;
        let player = this.props.player;
        let isLateOnboarding = getIsLateOnboardUser(gamedays, rawMatchDay);
        let showWarningText = false;
        let pStatusObj = config.statusIcons ? config.statusIcons : {};
        let pStatus, playerText = "";
        let UpcomingMd = rawMatchDay.mdId ? +rawMatchDay.mdId : "-";
        if (!hasTeam(this.props.loginData)) {
            if (player.teamPlayed) {
                showWarningText = true
                pStatus = showGeneric ? "" : config.warningStatus;
            }
        } else {
            //check for raw details
            let isPlayInTeam = isPlayerInTeam(player.id, teamData);
            if (isPlayInTeam) {
                //get player from team for Db details
                let extractedPlayer = getPlayerInteam(player.id, teamData);
                if (extractedPlayer) {
                    if (extractedPlayer.DBDetails && isLateOnboarding) {
                        if (!extractedPlayer.DBDetails.isactive) {
                            showWarningText = true
                            pStatus = showGeneric ? "" : config.warningStatus;
                        }
                    }
                }
            } else {
                if (player.teamPlayed && isLateOnboarding) {
                    showWarningText = true
                    pStatus = showGeneric ? "" : config.warningStatus;
                }
            }

        }

        if (player.pStatus && pStatus != config.warningStatus) {
            pStatus = player.pStatus;
        }
        let pStatusHeaderClass = pStatusObj[pStatus] ? pStatusObj[pStatus].bioClass : '';
        let iconClass = pStatusObj[pStatus] ? pStatusObj[pStatus].class : '';
        playerText = pStatusObj[pStatus] ? getTrans(trans, pStatusObj[pStatus].text, pStatusObj[pStatus].text) : '';

        if (showWarningText) {
            if (showGeneric) {

            } else {
                playerText = getTrans(trans, "PlayerBioText", "Already played on Matchday") + " " + UpcomingMd;
            }

        }
        if (pStatusHeaderClass && playerText) {
            return (
                <div className={ "si-plyr__status " + pStatusHeaderClass } >
                    <div className="si-plyr__icon"></div>
                    <span>{ playerText }</span>
                </div>
            )
        } else {
            return null
        }

    }
}

export default Consume(status, [LoginContext]);